import React, { memo, useState, useCallback } from "react";
import Button from "@material-ui/core/Button";
import type { FC } from "react";
import { Dialog } from "./Dialog";
import { useStyles } from "./DeleteBulkExportStateButton.styles";
import { useDeleteSettingsButton } from "./DeleteBulkExportStateButton.state";
import { useBulkExportContext } from "../../providers";
import { useSavedExportSettingsQuery } from "../../api";
import { BulkExportFormatEnum } from "../../api/mutations/saveBulkExportState/saveBulkExportState.types";
import { BulkExportFormat } from "../../types";
import { sortBy } from "lodash";

export const DeleteBulkExportStateButton: FC = memo(() => {
  const classes = useStyles();
  const { deleteExportSettings, nameOfSettings } = useDeleteSettingsButton();
  const [openDialog, setOpenDialog] = useState(false);
  const context = useBulkExportContext();
  const handleCloseDialog = useCallback(() => setOpenDialog(false), [setOpenDialog]);
  const { savedExportSettings } = useSavedExportSettingsQuery();
  const setSavedExportSettingsId = context?.actions.setSavedExportSettingsId;
  const setDataSourceId = context?.actions.setDataSourceId;
  const setCurrentSavedSettings = context?.actions.setCurrentSavedSettings;
  const handleSaveBulkExportState = useCallback(() => {
    deleteExportSettings();
    const defaultSavedExportSettings = sortBy(
      savedExportSettings?.filter((el) => el.name !== nameOfSettings),
      ["parentId", "name"]
    )[0];
    if (defaultSavedExportSettings && setSavedExportSettingsId) {
      setSavedExportSettingsId({
        id: defaultSavedExportSettings.id,
        dimensions: defaultSavedExportSettings.dimensions,
        format: BulkExportFormatEnum[defaultSavedExportSettings.format] as BulkExportFormat,
      });
      setDataSourceId && setDataSourceId(defaultSavedExportSettings.parentId);
      setCurrentSavedSettings && setCurrentSavedSettings(defaultSavedExportSettings);
    } else {
      context?.actions?.setDefaultDimensions();
      setSavedExportSettingsId?.({
        id: undefined,
        dimensions: [],
        format: BulkExportFormat.XLSX,
      });
    }
    setOpenDialog(false);
  }, [setOpenDialog, deleteExportSettings]);
  const handleClick = useCallback(() => {
    setOpenDialog(true);
  }, [setOpenDialog]);

  return (
    <>
      <Dialog open={openDialog} onCancel={handleCloseDialog} onApply={handleSaveBulkExportState} name={nameOfSettings} />
      <Button color="primary" variant="contained" onClick={handleClick} classes={classes}>
        Remove
      </Button>
    </>
  );
});
